import { createSlice } from "@reduxjs/toolkit";

const cmsDataSlice = createSlice({
  name: "cmsData",
  initialState: {
    cmsData: null,
    cmsBondListData: null,
  },

  reducers: {
    addCmsData: (state, action) => {
      state.cmsData = action.payload.cmsData;
      state.cmsBondListData = action.payload.bondsList;
    },
    updateCmsData: (state, action) => {
      state.cmsData = action.payload;
    },
    addfaqData: (state, action) => {
      state.cmsData.faq.push(action.payload);
    },
    removefaqData: (state, action) => {
      state.cmsData.faq = state.cmsData.faq.filter(
        (item) => item.questtion !== action.payload
      );
    },
  },
});

export const { addCmsData, updateCmsData, addfaqData, removefaqData } = cmsDataSlice.actions;

export default cmsDataSlice.reducer;
